import React from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Toast, CurrencyInput, Select } from '@app/components';
import SecondaryHeader from '@app/components/header-secondary';
import Switch from 'react-switch';
import { useLocation } from '@app/utils';
import MunicipalitylogoUrl from '@app/assets/images/Municipalitiesblack.svg';
import {
  FormContainer,
  BackgroundContainer,
  InfoBox,
  Heading,
  Text,
  InfoCard,
  PrimaryInfoCard,
  InfoItem,
  PrimaryInfoItem,
  SecondaryInfoItem,
  Loader,
  ErrorMessage,
  PrimaryInfoBox,
  RadioItem,
  SecondaryInfoCard,
  NumText,
  AddNewText,
  MultiInfoCard,
  TaxRate,
  Instcard,
  TaxInstcard,
  InspectionInst,
  PrimaryHeading,
  RemoveText,
  PriceErrorMessage,
  TaxText,
  SelectLabel,
  SelectItem,
  Star,
  Status,
  SwitchCard,
  Label,
} from './muncipalities-form-components';
import { Input, Icon } from '@app/components';
import Uploader from '@app/components/uploader';
import TextArea from '@app/components/textArea';
import RadioButton from '@app/components/radioButton';
import {
  useCreateMunicipalityMutation,
  useGetMunicipalityQuery,
  useEditMunicipalityMutation,
  useGetActiveCounties,
} from '@app/graphql';

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

type AdditionalQuestion = {
  questionId?: string;
  question: string;
  serialNo: number;
  municipalityId?: string;
  deleted?: boolean;
  id?: string;
};
type CountyProps = {
  key: string;
  name: string;
  _id: string;
  status: string;
};

type Exemption = {
  id?: string;
  exemption: string;
  deleted?: boolean;
};

export default function MuncipalityForm() {
  const { navigate } = useLocation();
  const { municipalityId }: any = useParams();
  const { register, errors, handleSubmit, formState } = useForm();
  const { isSubmitted } = formState;
  const [getActiveCounties] = useGetActiveCounties();
  const [emailError] = React.useState('');
  const [checked, setChecked] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [phone, setPhone] = React.useState('');
  const [fileName, setFileName] = React.useState('');
  const [profileImage, setProfileImage] = React.useState(MunicipalitylogoUrl);
  const [legalDescription, setLegalDescription] = React.useState('no');
  const [waterReading, setWaterReading] = React.useState('no');
  const [inspection, setInspection] = React.useState('no');
  const [taxProof, setTaxProof] = React.useState('no');
  const [inspectionDoc, setInspectionDoc] = React.useState('no');
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, updateToastMessage] = React.useState('');
  const [saving, updatesaving] = React.useState(false);
  const [disabled, updatedisabled] = React.useState(false);
  const [exemptionList, updateExemptionList] = React.useState<Exemption[]>([
    { exemption: '' },
  ]);
  const [recordList, updateRecordList] = React.useState(['']);
  const [quesList, updateQuesList] = React.useState<AdditionalQuestion[]>([
    { question: '', serialNo: 1 },
  ]);
  const [createMunicipality] = useCreateMunicipalityMutation();
  const [EditMunicipality] = useEditMunicipalityMutation();
  const { loading, data } = useGetMunicipalityQuery({
    id: municipalityId ? municipalityId : '',
  });
  const defaultStateSelectOption = {
    label: 'Illinois (IL)',
    value: '6214c9ab4b40aa5f023cd33e',
  };
  const [counties, setCounties] = React.useState([]);
  const [municipalityData, updateMunicipalityData] = React.useState({
    name: '',
    address: '',
    phoneNumber: '',
    website: '',
    email: '',
    city: '',
    taxExemption: '',
    state: defaultStateSelectOption,
    county: [],
    proofofTaxPaymentInstructions: '',
    transferDocumentTitle: '',
    instructionsAndNotes: '',
    nomenclatureOfTheTax: '',
    TaxCalculationsRate: '',
    TaxCalculationsInstructions: '',
    nomenclatureOfThePIN: '',
    WaterReadingInstructions: '',
    InspectionInstructions: '',
    nomenclatureOfTheRecorderBox: '',
    status: 'ACTIVE',
    minimumInspectionDays: '0',
  });

  React.useEffect(() => {
    getActiveCounties({
      variables: { stateId: defaultStateSelectOption.value },
    }).then((response: any) => {
      if (response && response.data) {
        const { getAllActiveCountiesOfState } = response.data;
        if (getAllActiveCountiesOfState) {
          const { counties } = getAllActiveCountiesOfState;
          if (counties && counties.length) {
            const formatedCounties = counties.map((county: CountyProps) => {
              return { ...county, label: county.name, value: county._id };
            });
            setCounties(formatedCounties);
          }
        }
      }
    });
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (!loading && data && data.municipality && data.municipality.success) {
      if (data.municipality.municipality) {
        const {
          municipality: { municipality },
        } = data;
        const InspectionInput: any = document.getElementById(
          'minimumInspectionDays',
        );
        updateMunicipalityData({
          name: municipality.name,
          address: municipality.address,
          phoneNumber: municipality.phoneNumber,
          website: municipality.website,
          email: municipality.email,
          transferDocumentTitle: municipality.transferDocumentTitle,
          instructionsAndNotes: municipality.instructionsAndNotes,
          nomenclatureOfTheTax: municipality.nomenclatureOfTheTax,
          TaxCalculationsRate: municipality.TaxCalculations.rate,
          TaxCalculationsInstructions:
            municipality.TaxCalculations.instructions,
          nomenclatureOfThePIN: municipality.nomenclatureOfThePIN,
          WaterReadingInstructions: municipality.waterReading.instructions,
          InspectionInstructions: municipality.inspection.instructions,
          nomenclatureOfTheRecorderBox:
            municipality.nomenclatureOfTheRecorderBox,
          status: municipality.status,
          proofofTaxPaymentInstructions:
            municipality.proofofTaxPayment.instructions,
          minimumInspectionDays: municipality.inspectionDaysMin || '0',
          city: municipality.city || '',
          county: municipality.counties || [],
          state: defaultStateSelectOption,
          taxExemption: municipality.taxExemption,
        });
        setPhone(municipality.phoneNumber);
        setProfileImage(
          municipality.logo ? municipality.logo : MunicipalitylogoUrl,
        );
        setFileName(municipality.logo);
        setTaxProof(municipality.proofofTaxPayment.required);
        setLegalDescription(municipality.includeLegalDescription);
        updateExemptionList(municipality.qualifyingExemptions);
        setWaterReading(municipality.waterReading.required);
        setInspection(municipality.inspection.required);
        setInspectionDoc(municipality.inspection.allowUsersToUploadDocs);
        updateRecordList(municipality.informationInTheRecordersBox);
        updateQuesList(municipality.additionalQuestions);
        setChecked(municipality.status === 'ACTIVE' ? true : false);
        if (InspectionInput) {
          InspectionInput.value = municipality.inspectionDaysMin;
        }
      }
    }
    // eslint-disable-next-line
  }, [loading, data]);
  const onPhoneChange = (event: any) => {
    setPhone(event);
  };
  const onTaxChange = (event: any, type: string) => {
    if (type === 'taxExemption') {
      updateMunicipalityData({
        ...municipalityData,
        taxExemption: event,
      });
    } else if (type === 'taxCalculationRate') {
      updateMunicipalityData({
        ...municipalityData,
        TaxCalculationsRate: event,
      });
    }
  };
  const onCountySelect = (e: any) => {
    updateMunicipalityData({ ...municipalityData, county: e });
  };
  /**
   *
   * @param event onchange event
   * @param index index of changed element
   */
  const onChange = (event: any, index?: number) => {
    const { name: fieldName, value: fieldValue } =
      (event && event.target) || '';
    if (fieldName === 'municipality') {
      updateMunicipalityData({ ...municipalityData, name: fieldValue });
    } else if (fieldName === 'city') {
      updateMunicipalityData({ ...municipalityData, city: fieldValue });
    } else if (fieldName === 'address') {
      updateMunicipalityData({
        ...municipalityData,
        address: fieldValue,
      });
    } else if (fieldName === 'email') {
      updateMunicipalityData({
        ...municipalityData,
        email: fieldValue,
      });
    } else if (fieldName === 'website') {
      updateMunicipalityData({
        ...municipalityData,
        website: fieldValue,
      });
    } else if (fieldName === 'phone') {
      updateMunicipalityData({
        ...municipalityData,
        phoneNumber: fieldValue,
      });
    } else if (fieldName === 'transferdoc') {
      updateMunicipalityData({
        ...municipalityData,
        transferDocumentTitle: fieldValue,
      });
    } else if (fieldName === 'notes') {
      updateMunicipalityData({
        ...municipalityData,
        instructionsAndNotes: fieldValue,
      });
    } else if (fieldName === 'taxname') {
      updateMunicipalityData({
        ...municipalityData,
        nomenclatureOfTheTax: fieldValue,
      });
    } else if (fieldName === 'taxinstructions') {
      updateMunicipalityData({
        ...municipalityData,
        TaxCalculationsInstructions: fieldValue,
      });
    } else if (fieldName === 'pin') {
      updateMunicipalityData({
        ...municipalityData,
        nomenclatureOfThePIN: fieldValue,
      });
    } else if (fieldName === 'waterreadtitle') {
      updateMunicipalityData({
        ...municipalityData,
        WaterReadingInstructions: fieldValue,
      });
    } else if (fieldName === 'nomenclature') {
      updateMunicipalityData({
        ...municipalityData,
        nomenclatureOfTheRecorderBox: fieldValue,
      });
    } else if (fieldName === 'inspectioninst') {
      updateMunicipalityData({
        ...municipalityData,
        InspectionInstructions: fieldValue,
      });
    } else if (fieldName === 'ProofInst') {
      updateMunicipalityData({
        ...municipalityData,
        proofofTaxPaymentInstructions: fieldValue,
      });
    } else if (fieldName && fieldName.startsWith('exemptions')) {
      if (index !== undefined) {
        const eId = event.target.id;
        let t_exemptionList = [...exemptionList];
        if (eId) {
          const exemptIndex = t_exemptionList.findIndex(e => e.id === eId);
          Object.assign(t_exemptionList[exemptIndex], {
            exemption: fieldValue,
          });
          if (municipalityId) {
            Object.assign(t_exemptionList[exemptIndex], {
              exemption: fieldValue,
            });
          }
        } else {
          t_exemptionList[index].exemption = fieldValue;
        }
        updateExemptionList(t_exemptionList);
      }
    } else if (fieldName && fieldName.startsWith('recordbox')) {
      if (index !== undefined) {
        let t_recordList = [...recordList];
        t_recordList[index] = fieldValue;
        updateRecordList(t_recordList);
      }
    } else if (fieldName === 'minimumInspectionDays') {
      updateMunicipalityData({
        ...municipalityData,
        minimumInspectionDays: fieldValue,
      });
    } else if (fieldName && fieldName.startsWith('question')) {
      if (index !== undefined) {
        const qId = event.target.id;
        let t_quesList = [...quesList];
        if (qId) {
          const quesIndex = t_quesList.findIndex(q => q.id === qId);
          Object.assign(t_quesList[quesIndex], {
            question: fieldValue,
          });
          if (municipalityId) {
            Object.assign(t_quesList[quesIndex], {
              municipalityId: municipalityId,
            });
          }
        } else {
          t_quesList[index].question = fieldValue;
        }
        updateQuesList(t_quesList);
      }
    }
  };

  const onProfileImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setFileName(event.target.files[0].name);
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setProfileImage(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  const deleteImage = () => {
    setFileName('');
    setProfileImage(MunicipalitylogoUrl);
  };

  const handleAddClick = () => {
    updateExemptionList([
      ...exemptionList,
      {
        exemption: '',
        id: 'new_e_' + randomString(6),
      },
    ]);
  };
  const handleRecordAddClick = () => {
    updateRecordList([...recordList, '']);
  };

  function randomString(length: number) {
    return Math.round(
      Math.pow(36, length + 1) - Math.random() * Math.pow(36, length),
    )
      .toString(36)
      .slice(1);
  }

  const handleQuesAddClick = () => {
    const serialNo: number = quesList.length;
    updateQuesList([
      ...quesList,
      {
        question: '',
        serialNo: serialNo + 1,
        id: 'new_q_' + randomString(6),
      },
    ]);
  };

  const setToast = (
    message: string,
    navigatePage?: boolean,
    isEdit?: boolean,
  ) => {
    updateToastMessage(message);
    setShowToast(true);
    setTimeout(
      () => {
        setShowToast(false);
        setIsError(false);
        if (navigatePage) {
          if (isEdit) {
            navigate('/municipalities/details/' + municipalityId);
          } else {
            navigate('/municipalities');
          }
        }
      },
      navigatePage ? 3000 : 500,
    );
  };

  const onSubmit = () => {
    if (
      !municipalityData.TaxCalculationsRate ||
      !municipalityData.county.length ||
      !municipalityData.state.value
    )
      return;
    let params = {
      name: municipalityData.name,
      address: municipalityData.address,
      taxExemption: municipalityData.taxExemption || '',
      logo: profileImage === MunicipalitylogoUrl ? '' : profileImage,
      phoneNumber: phone,
      website: municipalityData.website,
      email: municipalityData.email,
      transferDocumentTitle: municipalityData.transferDocumentTitle,
      instructionsAndNotes: municipalityData.instructionsAndNotes,
      includeLegalDescription: legalDescription,
      qualifyingExemptions: exemptionList,
      nomenclatureOfTheTax: municipalityData.nomenclatureOfTheTax,
      TaxCalculationsRate: municipalityData.TaxCalculationsRate,
      TaxCalculationsInstructions: municipalityData.TaxCalculationsInstructions,
      proofofTaxPaymentRequired: taxProof,
      proofofTaxPaymentInstructions:
        municipalityData.proofofTaxPaymentInstructions,
      nomenclatureOfThePIN: municipalityData.nomenclatureOfThePIN,
      WaterReadingRequired: waterReading,
      WaterReadingInstructions: municipalityData.WaterReadingInstructions,
      InspectionRequired: inspection,
      InspectionInstructions: municipalityData.InspectionInstructions,
      InspectionAllowUsersToUploadDocs: inspectionDoc,
      nomenclatureOfTheRecorderBox:
        municipalityData.nomenclatureOfTheRecorderBox,
      informationInTheRecordersBox: recordList,
      additionalQuestions: quesList,
      status: checked ? 'ACTIVE' : 'INACTIVE',
      inspectionDaysMin: parseInt(municipalityData.minimumInspectionDays),
      stateId: municipalityData.state.value,
      city: municipalityData.city,
      counties:
        municipalityData.county && municipalityData.county.length
          ? municipalityData.county.map((county: any) => {
              let object = {
                countyId: county.value,
              };
              return object;
            })
          : [],
    };
    updatesaving(true);
    updatedisabled(true);
    if (municipalityId && municipalityId.length) {
      Object.assign(params, { id: municipalityId });
      EditMunicipality({
        variables: params,
      })
        .then((res: any) => {
          updatesaving(false);
          updatedisabled(false);
          if (res.data.editMunicipality.success) {
            setToast('Municipality updated Succesfully', true, true);
          } else {
            setIsError(true);
            setToast(res.data.editMunicipality.message);
          }
        })
        .catch((err: any) => {
          updatesaving(false);
          updatedisabled(false);
          updatesaving(false);
          setIsError(true);
          setToast('Something went wrong...');
        });
    } else {
      createMunicipality({
        variables: params,
      })
        .then((res: any) => {
          updatesaving(false);
          updatedisabled(false);
          if (res.data.createMunicipality.success) {
            setToast('Municipality created Succesfully', true);
          } else {
            setIsError(true);
            setToast(res.data.createMunicipality.message);
          }
        })
        .catch((err: any) => {
          setIsError(true);
          setToast('Something went wrong....');
          updatesaving(false);
          updatedisabled(false);
          updatesaving(false);
        });
    }
  };
  const removeArrEle = (arr: Array<any>, index: number) => {
    return arr.slice(0, index).concat(arr.slice(index + 1));
  };
  const handleRemoveExemption = (index: number, eId?: string) => {
    const list = [...exemptionList];
    const exemptIndex = list.findIndex(e => e.id === eId);
    if (municipalityId && exemptIndex !== undefined) {
      Object.assign(list[exemptIndex], {
        deleted: true,
      });
      updateExemptionList(list);
    } else {
      const updatedList = removeArrEle(list, index);
      updateExemptionList(updatedList);
    }
  };

  const handleRemoveRecorderBox = (index: number) => {
    const list = [...recordList];
    const updatedList = removeArrEle(list, index);
    updateRecordList(updatedList);
  };

  const handleRemovequestions = (index: number, qId?: string) => {
    const list = [...quesList];
    const quesIndex = list.findIndex(q => q.id === qId);
    if (municipalityId && quesIndex !== undefined) {
      Object.assign(list[quesIndex], {
        deleted: true,
      });
      updateQuesList(list);
    } else {
      const updatedList = removeArrEle(list, quesIndex);
      updateQuesList(updatedList);
    }
  };

  return (
    <>
      <BackgroundContainer>
        <Toast
          message={toastMessage}
          showToast={showToast}
          isError={isError}
          onClose={() => setShowToast(false)}
        />
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <SecondaryHeader
            title={
              municipalityId && municipalityId.length
                ? 'Edit Municipality'
                : 'Create Municipality'
            }
            onBackClick={() =>
              navigate(
                municipalityId && municipalityId.length
                  ? '/municipalities/details/' + municipalityId
                  : '/municipalities',
              )
            }
            primaryButtonText="Save Municipality"
            showPrimaryButton={true}
            disabledPrimaryButton={disabled}
            showButton={true}
            secondaryButtonText="Cancel"
            onSecondaryButtonClick={() =>
              navigate(
                municipalityId && municipalityId.length
                  ? '/municipalities/details/' + municipalityId
                  : '/municipalities',
              )
            }
            saving={saving}
          />
          {municipalityId && loading ? (
            <Loader>
              <Icon name="loader" />
            </Loader>
          ) : (
            <FormContainer>
              <>
                <InfoBox>
                  <PrimaryHeading>Municipality Information</PrimaryHeading>
                  <Status>
                    <SwitchCard>
                      <Switch
                        onChange={() => {
                          setChecked(!checked);
                        }}
                        checked={checked}
                        onColor="#D1D7FA"
                        onHandleColor="#4D5DC7"
                        offHandleColor="#4D5DC7"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 5px 10px rgba(13 18 51/ 10%)"
                        activeBoxShadow="0px 5px 10px rgba(78 96 196/ 10%)"
                        height={14}
                        width={40}
                        className="react-switch"
                        id="material-switch"
                      />
                    </SwitchCard>
                    <Label>{checked ? 'Active' : 'Inactive'}</Label>
                  </Status>
                  <Text>
                    Please enter the following information of the specific
                    municipality
                  </Text>
                  <InfoCard>
                    <InfoItem>
                      <Input
                        star="*"
                        label="Municipality"
                        placeholder="Enter Municipality"
                        name="municipality"
                        showDefaultValue={true}
                        value={
                          municipalityData && municipalityData.name
                            ? municipalityData.name
                            : ''
                        }
                        onChange={onChange}
                        register={register({ required: true })}
                      />
                      {errors.municipality && (
                        <ErrorMessage>Please Enter Municipality</ErrorMessage>
                      )}
                    </InfoItem>
                    <SelectItem>
                      <SelectLabel>State</SelectLabel>
                      <Star>*</Star>
                      <Select
                        options={[]}
                        disabled={true}
                        placeholder="Please Select"
                        value={municipalityData.state}
                        onChange={e => onChange}
                        register={register({
                          required: true,
                          name: 'state',
                        })}
                      />
                      {isSubmitted &&
                      municipalityData.state &&
                      !municipalityData.state.value ? (
                        <ErrorMessage>Please select state</ErrorMessage>
                      ) : null}
                    </SelectItem>
                  </InfoCard>
                  <InfoCard>
                    <SelectItem>
                      <SelectLabel>County</SelectLabel>
                      <Star>*</Star>
                      <Select
                        options={counties}
                        placeholder="Please Select"
                        value={municipalityData.county}
                        onChange={e => onCountySelect(e)}
                        isMulti={true}
                        register={register({
                          required: true,
                          name: 'county',
                        })}
                      />
                      {isSubmitted &&
                      municipalityData.county &&
                      !municipalityData.county.length ? (
                        <ErrorMessage>Please select county</ErrorMessage>
                      ) : null}
                    </SelectItem>
                    <InfoItem
                      style={{ paddingLeft: '20px', paddingRight: '0px' }}>
                      <Input
                        star="*"
                        label="City"
                        placeholder="Enter City"
                        name="city"
                        showDefaultValue={true}
                        value={
                          municipalityData && municipalityData.city
                            ? municipalityData.city
                            : ''
                        }
                        onChange={onChange}
                        register={register({ required: true })}
                      />
                      {errors.municipality && (
                        <ErrorMessage>Please Enter City</ErrorMessage>
                      )}
                    </InfoItem>
                  </InfoCard>
                  <PrimaryInfoCard>
                    <SecondaryInfoItem>
                      <Input
                        label="Address"
                        star="*"
                        showDefaultValue={true}
                        placeholder="Enter Address"
                        name="address"
                        value={
                          municipalityData && municipalityData.address
                            ? municipalityData.address
                            : ''
                        }
                        onChange={onChange}
                        register={register({ required: true })}
                      />
                      {errors.address && (
                        <ErrorMessage>Please Enter Address</ErrorMessage>
                      )}
                    </SecondaryInfoItem>
                  </PrimaryInfoCard>
                  <PrimaryInfoCard>
                    <InfoItem>
                      <Input
                        label="Minimum Inspection Days"
                        type="number"
                        star="*"
                        id="minimumInspectionDays"
                        placeholder="Enter Minimum Inspection Days"
                        name="minimumInspectionDays"
                        value={
                          municipalityData &&
                          municipalityData.minimumInspectionDays
                            ? municipalityData.minimumInspectionDays
                            : ''
                        }
                        showDefaultValue={true}
                        onChange={onChange}
                        register={register({
                          required: true,
                        })}
                      />
                      {errors && errors.minimumInspectionDays && (
                        <ErrorMessage>
                          Please Enter Minimum Inspection Days
                        </ErrorMessage>
                      )}
                    </InfoItem>
                    <InfoItem>
                      <Input
                        label="Email"
                        type="email"
                        star="*"
                        placeholder="Enter Email"
                        name="email"
                        value={
                          municipalityData && municipalityData.email
                            ? municipalityData.email
                            : ''
                        }
                        showDefaultValue={true}
                        onChange={onChange}
                        register={register({
                          required: true,
                          pattern: emailPattern,
                        })}
                      />
                      {errors.email && errors.email.type === 'required' && (
                        <ErrorMessage>Please Enter Email</ErrorMessage>
                      )}
                      {errors.email && errors.email.type === 'pattern' && (
                        <ErrorMessage>Please Enter valid email</ErrorMessage>
                      )}
                      {!errors.email && emailError && (
                        <ErrorMessage>{emailError}</ErrorMessage>
                      )}
                    </InfoItem>
                  </PrimaryInfoCard>
                  <PrimaryInfoCard>
                    <InfoItem>
                      <Input
                        type="url"
                        label="Website"
                        placeholder="Enter Website"
                        name="website"
                        value={
                          municipalityData && municipalityData.website
                            ? municipalityData.website
                            : ''
                        }
                        showDefaultValue={true}
                        onChange={onChange}
                        register={register({})}
                      />
                    </InfoItem>
                    <InfoItem>
                      <Input
                        label="Phone Number"
                        type="phone_number"
                        placeholder="Enter Phone Number"
                        name="phone"
                        value={phone}
                        onChange={(e: any) => onPhoneChange(e)}
                        register={register()}
                      />
                    </InfoItem>
                  </PrimaryInfoCard>
                  <PrimaryInfoCard>
                    <InfoItem>
                      <Uploader
                        onChange={e => onProfileImageChange(e)}
                        fileName={fileName}
                        profileImage={profileImage}
                        label="Logo"
                        borderRadius={'8px'}
                        changetext="Change"
                        chooseText="Choose Municipality Logo"
                        onImageDelete={deleteImage}
                      />
                    </InfoItem>
                  </PrimaryInfoCard>
                </InfoBox>
                <InfoBox>
                  <Heading>Title of Transfer Document</Heading>
                  <Text>
                    Please enter the official title this municipality would like
                    to use for this process (e.g. Real Estate Transfer
                    Declaration)
                  </Text>
                  <InfoCard>
                    <PrimaryInfoItem>
                      <Input
                        placeholder="Enter Title"
                        name="transferdoc"
                        showDefaultValue={true}
                        value={
                          municipalityData &&
                          municipalityData.transferDocumentTitle
                            ? municipalityData.transferDocumentTitle
                            : ''
                        }
                        onChange={onChange}
                        register={register({})}
                      />
                    </PrimaryInfoItem>
                  </InfoCard>
                </InfoBox>
                <PrimaryInfoBox>
                  <Heading>Instructions and Notes</Heading>
                  <Text>
                    Please enter any specific notes and instructions for this
                    municipality
                  </Text>
                  <PrimaryInfoItem>
                    <TextArea
                      showDefaultValue={true}
                      placeholder="Notes and Instructions (any)"
                      name="notes"
                      value={
                        municipalityData &&
                        municipalityData.instructionsAndNotes
                          ? municipalityData.instructionsAndNotes
                          : ''
                      }
                      onChange={onChange}
                      register={register({})}
                    />
                  </PrimaryInfoItem>
                </PrimaryInfoBox>
                <PrimaryInfoBox>
                  <Heading>Include “Legal Description”?</Heading>
                  <Text>
                    Does this municipality want to include this section in their
                    process?
                  </Text>
                  <InfoCard>
                    <RadioItem>
                      <RadioButton
                        label="Yes"
                        name="legaldescription"
                        checked={legalDescription === 'yes'}
                        value={'yes'}
                        onChange={() => {
                          setLegalDescription('yes');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                    <RadioItem>
                      <RadioButton
                        label="No"
                        name="legaldescription"
                        checked={legalDescription === 'no'}
                        value={'no'}
                        onChange={() => {
                          setLegalDescription('no');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                  </InfoCard>
                </PrimaryInfoBox>
                <PrimaryInfoBox>
                  <Heading>Qualifying Exemptions</Heading>
                  <Text>
                    Please add all of the possible exemptions for this
                    municipality
                  </Text>
                  <SecondaryInfoCard>
                    {exemptionList
                      .filter(e => !e.deleted)
                      .map((data, i) => {
                        return (
                          <MultiInfoCard key={i}>
                            <NumText>{i + 1}.</NumText>
                            <PrimaryInfoItem>
                              <Input
                                id={data.id}
                                showDefaultValue={true}
                                placeholder="Enter Exemption"
                                name={`exemptions[${i}]`}
                                value={data.exemption}
                                onChange={(e: any) => {
                                  onChange(e, i);
                                }}
                                register={register({})}
                              />
                            </PrimaryInfoItem>
                            {exemptionList.filter(e => !e.deleted).length >
                              1 && (
                              <RemoveText
                                onClick={() => {
                                  handleRemoveExemption(i, data.id);
                                }}>
                                Remove
                              </RemoveText>
                            )}
                          </MultiInfoCard>
                        );
                      })}
                    <InfoCard>
                      <AddNewText onClick={handleAddClick}>ADD NEW</AddNewText>
                    </InfoCard>
                  </SecondaryInfoCard>
                </PrimaryInfoBox>
                <PrimaryInfoBox>
                  <Heading>Nomenclature of the Tax</Heading>
                  <Text>
                    Please enter the official name of the tax this municipality
                    would like to use
                  </Text>
                  <InfoCard>
                    <PrimaryInfoItem>
                      <Input
                        placeholder="Enter Name of the Tax"
                        name="taxname"
                        showDefaultValue={true}
                        value={
                          municipalityData &&
                          municipalityData.nomenclatureOfTheTax
                            ? municipalityData.nomenclatureOfTheTax
                            : ''
                        }
                        onChange={onChange}
                        register={register({})}
                      />
                    </PrimaryInfoItem>
                  </InfoCard>
                </PrimaryInfoBox>
                <InfoBox>
                  <Heading>
                    Tax Calculations<strong style={{ color: 'red' }}>*</strong>
                  </Heading>
                  <Text>
                    Please enter the tax rate and instructions this municipality
                    would like to use
                  </Text>
                  <InfoCard>
                    <TaxRate>
                      <CurrencyInput
                        placeholder="Rate"
                        name="taxcaluculation"
                        value={
                          municipalityData &&
                          municipalityData.TaxCalculationsRate
                            ? municipalityData.TaxCalculationsRate
                            : ''
                        }
                        onChange={(e: any) =>
                          onTaxChange(e, 'taxCalculationRate')
                        }
                        register={register({ required: true })}
                      />
                    </TaxRate>
                    <TaxText>per $1000 of full actual consideration</TaxText>
                  </InfoCard>
                  {isSubmitted && !municipalityData.TaxCalculationsRate && (
                    <PriceErrorMessage>Please Enter Tax Rate</PriceErrorMessage>
                  )}
                  <InfoCard>
                    <InfoItem>
                      <Heading>
                        Tax Exemption
                        <strong style={{ color: 'red' }}>*</strong>
                      </Heading>
                      <CurrencyInput
                        placeholder="Enter Exemption Cost"
                        name="taxExemption"
                        value={
                          municipalityData && municipalityData.taxExemption
                            ? municipalityData.taxExemption
                            : ''
                        }
                        onChange={(e: any) => onTaxChange(e, 'taxExemption')}
                        register={register({})}
                        // required: true
                      />
                      {errors.taxExemption && (
                        <ErrorMessage>Please Enter Tax Exemption</ErrorMessage>
                      )}
                    </InfoItem>
                  </InfoCard>
                  <TaxInstcard>
                    <Text>Instructions</Text>
                    <SecondaryInfoItem>
                      <TextArea
                        showDefaultValue={true}
                        placeholder="Instructions (any)"
                        name="taxinstructions"
                        value={
                          municipalityData &&
                          municipalityData.TaxCalculationsInstructions
                            ? municipalityData.TaxCalculationsInstructions
                            : ''
                        }
                        onChange={onChange}
                        register={register({})}
                      />
                    </SecondaryInfoItem>
                  </TaxInstcard>
                </InfoBox>
                <PrimaryInfoBox>
                  <Heading>Proof of Tax Payment</Heading>
                  <Text>
                    Does the municipality require proof of tax payment?
                  </Text>
                  <InfoCard>
                    <RadioItem>
                      <RadioButton
                        label="Yes"
                        name="taxproof"
                        checked={taxProof === 'yes'}
                        value={'yes'}
                        onChange={() => {
                          setTaxProof('yes');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                    <RadioItem>
                      <RadioButton
                        label="No"
                        name="taxproof"
                        checked={taxProof === 'no'}
                        value={'no'}
                        onChange={() => {
                          setTaxProof('no');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                  </InfoCard>
                </PrimaryInfoBox>
                {taxProof === 'yes' ? (
                  <Instcard>
                    <Text> Instructions</Text>
                    <Text>
                      Please enter the Proof of Tax Payment instructions for
                      this municipality
                    </Text>
                    <InfoCard>
                      <PrimaryInfoItem>
                        <TextArea
                          showDefaultValue={true}
                          value={municipalityData.proofofTaxPaymentInstructions}
                          placeholder="Instructions (any)"
                          name="ProofInst"
                          onChange={onChange}
                          register={register({})}
                        />
                      </PrimaryInfoItem>
                    </InfoCard>
                  </Instcard>
                ) : null}
                <PrimaryInfoBox>
                  <Heading>Nomenclature of PIN</Heading>
                  <Text>
                    Please enter the title this municipality would like to use
                    for this field
                  </Text>
                  <InfoCard>
                    <PrimaryInfoItem>
                      <Input
                        showDefaultValue={true}
                        placeholder="Enter Title"
                        name="pin"
                        value={
                          municipalityData &&
                          municipalityData.nomenclatureOfThePIN
                            ? municipalityData.nomenclatureOfThePIN
                            : ''
                        }
                        onChange={onChange}
                        register={register({})}
                      />
                    </PrimaryInfoItem>
                  </InfoCard>
                </PrimaryInfoBox>
                <InfoBox>
                  <Heading>Require Water Reading?</Heading>
                  <Text>
                    Does the municipality require a final water reading of the
                    property?
                  </Text>
                  <InfoCard>
                    <RadioItem>
                      <RadioButton
                        label="Yes"
                        name="waterreading"
                        checked={waterReading === 'yes'}
                        value={'yes'}
                        onChange={() => {
                          setWaterReading('yes');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                    <RadioItem>
                      <RadioButton
                        label="No"
                        name="waterreading"
                        checked={waterReading === 'no'}
                        value={'no'}
                        onChange={() => {
                          setWaterReading('no');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                  </InfoCard>
                </InfoBox>
                {waterReading === 'yes' ? (
                  <Instcard>
                    <Text> Instructions</Text>
                    <Text>
                      Please enter the water reading instructions for this
                      municipality
                    </Text>
                    <InfoCard>
                      <PrimaryInfoItem>
                        <TextArea
                          showDefaultValue={true}
                          placeholder="Instructions (any)"
                          name="waterreadtitle"
                          value={
                            municipalityData &&
                            municipalityData.WaterReadingInstructions
                              ? municipalityData.WaterReadingInstructions
                              : ''
                          }
                          onChange={onChange}
                          register={register({})}
                        />
                      </PrimaryInfoItem>
                    </InfoCard>
                  </Instcard>
                ) : null}
                <PrimaryInfoBox>
                  <Heading>Require Inspection?</Heading>
                  <Text>
                    Does the municipality require “point of sale” inspection of
                    the property?
                  </Text>
                  <InfoCard>
                    <RadioItem>
                      <RadioButton
                        label="Yes"
                        name="inspection"
                        checked={inspection === 'yes'}
                        value={'yes'}
                        onChange={() => {
                          setInspection('yes');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                    <RadioItem>
                      <RadioButton
                        label="No"
                        name="inspection"
                        checked={inspection === 'no'}
                        value={'no'}
                        onChange={() => {
                          setInspection('no');
                        }}
                        register={register({})}
                      />
                    </RadioItem>
                  </InfoCard>
                </PrimaryInfoBox>
                {inspection === 'yes' ? (
                  <InspectionInst>
                    <Instcard>
                      <Text>Instructions</Text>
                      <Text>
                        Please enter the inspection instructions for this
                        municipality
                      </Text>
                      <InfoCard>
                        <PrimaryInfoItem>
                          <TextArea
                            showDefaultValue={true}
                            placeholder="Instructions (any)"
                            name="inspectioninst"
                            value={
                              municipalityData &&
                              municipalityData.InspectionInstructions
                                ? municipalityData.InspectionInstructions
                                : ''
                            }
                            onChange={onChange}
                            register={register({})}
                          />
                        </PrimaryInfoItem>
                      </InfoCard>
                    </Instcard>
                    <Instcard>
                      <Text>Allow for Inspection Document Upload?</Text>
                      <Text>
                        Does the municipality allow users to upload inspection
                        documents?
                      </Text>
                      <InfoCard>
                        <RadioItem>
                          <RadioButton
                            label="Yes"
                            name="inspection-doc"
                            checked={inspectionDoc === 'yes'}
                            value={'yes'}
                            onChange={() => {
                              setInspectionDoc('yes');
                            }}
                            register={register({})}
                          />
                        </RadioItem>
                        <RadioItem>
                          <RadioButton
                            label="No"
                            name="inspectiondoc"
                            checked={inspectionDoc === 'no'}
                            value={'no'}
                            onChange={() => {
                              setInspectionDoc('no');
                            }}
                            register={register({})}
                          />
                        </RadioItem>
                      </InfoCard>
                    </Instcard>
                  </InspectionInst>
                ) : null}
                <PrimaryInfoBox>
                  <Heading>Nomenclature of the Recorder’s Box</Heading>
                  <Text>
                    Please enter the name of the recorder’s box that this
                    municipality would like to use.
                  </Text>
                  <InfoCard>
                    <PrimaryInfoItem>
                      <Input
                        placeholder="Enter Name"
                        name="nomenclature"
                        showDefaultValue={true}
                        value={
                          municipalityData &&
                          municipalityData.nomenclatureOfTheRecorderBox
                            ? municipalityData.nomenclatureOfTheRecorderBox
                            : ''
                        }
                        onChange={onChange}
                        register={register({})}
                      />
                    </PrimaryInfoItem>
                  </InfoCard>
                </PrimaryInfoBox>
                <PrimaryInfoBox>
                  <Heading>Information in the Recorder’s Box</Heading>
                  <Text>
                    Please add all of the text box fields that this municipality
                    requires in the Recorder’s Box
                  </Text>
                  <SecondaryInfoCard>
                    {recordList.map((data, i) => {
                      return (
                        <MultiInfoCard key={i}>
                          <NumText>{i + 1}.</NumText>
                          <PrimaryInfoItem>
                            <Input
                              showDefaultValue={true}
                              placeholder="Please Add Information"
                              name={`recordbox[${i}]`}
                              value={data}
                              onChange={(e: any) => {
                                onChange(e, i);
                              }}
                              register={register({})}
                            />
                          </PrimaryInfoItem>
                          {recordList.length > 1 && (
                            <RemoveText
                              onClick={() => {
                                handleRemoveRecorderBox(i);
                              }}>
                              Remove
                            </RemoveText>
                          )}
                        </MultiInfoCard>
                      );
                    })}
                    <InfoCard>
                      <AddNewText onClick={handleRecordAddClick}>
                        ADD NEW
                      </AddNewText>
                    </InfoCard>
                  </SecondaryInfoCard>
                </PrimaryInfoBox>
                <PrimaryInfoBox>
                  <Heading>Additional Questions</Heading>
                  <Text>
                    Please add any additional questions for this municipality
                  </Text>
                  <SecondaryInfoCard>
                    {quesList
                      .filter(q => !q.deleted)
                      .map((data, i) => {
                        return (
                          <MultiInfoCard key={i}>
                            <NumText>{i + 1}. </NumText>
                            <PrimaryInfoItem>
                              <Input
                                showDefaultValue={true}
                                id={data.id}
                                placeholder="Questions (any)"
                                name={`question[${i}]`}
                                value={data.question}
                                onChange={(e: any) => {
                                  onChange(e, i);
                                }}
                                register={register({})}
                              />
                            </PrimaryInfoItem>
                            {quesList.filter(q => !q.deleted).length > 1 && (
                              <RemoveText
                                onClick={() => {
                                  handleRemovequestions(i, data.id);
                                }}>
                                Remove
                              </RemoveText>
                            )}
                          </MultiInfoCard>
                        );
                      })}
                    <InfoCard>
                      <AddNewText onClick={handleQuesAddClick}>
                        ADD NEW
                      </AddNewText>
                    </InfoCard>
                  </SecondaryInfoCard>
                </PrimaryInfoBox>
              </>
            </FormContainer>
          )}
        </form>
      </BackgroundContainer>
    </>
  );
}
